const replacedOptionsMessage = 'Previously selected options are no longer available.';

export default {
  replacedOptionsMessage,
};
